import React, { useState } from "react";
import { Grid } from "@mui/material";
import styled from "styled-components";
import { ReactSVG } from "react-svg";
import { toast } from "react-toastify";

import api from "../../../../../services/api";
import Modal from "../../../../../components/Modal";
import FrontCredito from "../../../../../assets/navbar/Front_Credito_on_light_blue.svg";
import SearchableSelect from "../../../../../components/SearchableSelect";
import Input from "../../Input";
import ReadOnlyInput from "../../ReadOnlyInput";
import Button from "../../../../../components/Button-v2";
import { Card, Label } from "../../styles";

const selectLabelStyles = {
  paddingBottom: "3.3px",
  lineHeight: 1.17,
  fontWeight: "normal",
  fontSize: "12px",
  opacity: 0.9,
};

const EventsModalV2 = (props) => {
  const {
    cpfCnpj,
    eventTypes,
    eventTypesLoading,
    open,
    onClose,
    reloadEvents,
  } = props;

  const [selectedEventType, setSelectedEventType] = useState(undefined);
  const [note, setNote] = useState("");

  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setSelectedEventType(undefined);
    setNote("");

    onClose();
  };

  const saveEvent = () => {
    const data = {
      cpfCnpj: cpfCnpj,
      codigoEvento: selectedEventType.codigo,
      observacao: note,
    };

    setLoading(true);
    api
      .post(`/api/front-credito/eventos-v2`, data)
      .then(() => {
        toast.success("Dados salvos com sucesso!");
        reloadEvents();
        handleClose();
      })
      .catch(() => {
        toast.error("Erro ao salvar os dados.");
      })
      .finally(() => setLoading(false));
  };

  const disableButton = !cpfCnpj || !selectedEventType;

  return (
    <Modal open={open} onClose={handleClose}>
      <Header>
        <IconWrapper>
          <ReactSVG src={FrontCredito} />
        </IconWrapper>
        <TitleWrapper>
          <Title>Front de crédito</Title>
          <Subtitle>Análise de Crédito</Subtitle>
        </TitleWrapper>
      </Header>
      <Body>
        <Label>Registro de eventos</Label>
        <Card>
          <Grid container spacing={3}>
            <Grid item md={6}>
              <SearchableSelect
                entries={eventTypes}
                label="Tipo de evento"
                labelStyles={selectLabelStyles}
                isLoading={eventTypesLoading}
                parser={(it) => ({
                  value: it.codigo,
                  label: `${it.descricao} (${it.codigo})`,
                })}
                placeholder="Selecione"
                selected={selectedEventType}
                setSelected={setSelectedEventType}
              />
            </Grid>
            <Grid item md={6}>
              <ReadOnlyInput
                label="Descrição do evento"
                value={selectedEventType?.descricao}
                height={38}
              />
            </Grid>
            <Grid item md={12}>
              <Input
                label="Observação"
                value={note}
                disabled={loading}
                onChange={setNote}
                defaultValue=""
                height={200}
                type="textarea"
                align="flex-start"
              />
            </Grid>
          </Grid>
          <ButtonWrapper>
            <Button
              height="34px"
              width="120px"
              loading={loading}
              disabled={disableButton}
              onClick={saveEvent}
            >
              Salvar
            </Button>
          </ButtonWrapper>
        </Card>
      </Body>
    </Modal>
  );
};

const Header = styled.div`
  display: flex;
  flex-direction: row;

  border-bottom: 3px solid #00a2e0;
`;

const IconWrapper = styled.div`
  width: 50px;
  height: 50px;

  svg {
    width: 50px;
    height: 50px;
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: space-between;

  margin: 0px 5px;
`;

const Title = styled.div`
  font-size: 18px;
  font-family: Roboto;
  font-weight: bold;
  line-height: 1.22;
  color: #383838;
`;

const Subtitle = styled.div`
  font-size: 15px;
  font-family: Roboto;
  font-weight: 500;
  line-height: 1.2;
  color: #747576;
`;

const Body = styled.div`
  margin-top: 32px;
  width: 700px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;

  margin-top: 32px;
`;

export default EventsModalV2;
